module.exports = __webpack_public_path__ + "img/UTPIUT-8.63947e1d.jpg";